import axios from "../plugins/parseAxios";
export class ProductAPI {
  constructor(props) {}
  static getProducts(payload) {
    return axios.post("functions/getProducts", {
      projectId: payload.projectId,
    });
  }
  static createProduct(payload) {
    return axios.post("functions/createProduct", payload);
  }
  static updateProduct(payload) {
    return axios.post("functions/updateProduct", payload);
  }
  static removeProduct(id) {
    return axios.post("functions/removeProduct", { id });
  }
}
